<template>
    <div id="video-home">
        <!--<video ref="video" v-show="this.$store.state.app.playVideoHome || isPlayingHome || isMobile" :class="{ 'is-playing': isPlayingHome }">
            <video ref="video_home" muted loop :class="{ 'is-playing': isPlayingHome }" v-if="!isMobile">-->
        <video ref="video_home" muted playsinline :class="{ 'is-playing': isPlayingHome }" loop :poster="srcPoster">
            <source :src="srcVideoMp4" type="video/mp4" />
        </video>

        <!--<video ref="video_home" muted loop :class="{ 'is-playing': isPlayingHome }" v-if="isMobile">
                <source :src="require('@/assets/showreel_mobil.mp4')" type="video/mp4" />
            </video>-->

        <div id="controls">
            <div @click="playVideo" class="btn-play">
                <PlayVideo v-if="!this.$store.state.app.playVideoHome && !endVideo" class="icon-play" />
                <PauseVideo v-if="this.$store.state.app.playVideoHome && !endVideo" class="icon-pause" />
            </div>

            <div @click="reloadVideo" class="btn-reload">
                <Reload v-if="!this.$store.state.app.playVideoHome && endVideo" class="icon-reload" />
            </div>

            <div @click="runMute()" class="btn-mute">
                <SoundOn v-if="!soundMuted" />
                <SoundOff v-if="soundMuted" />
            </div>
        </div>

        <div id="timer-video">
            <div>
                {{ timer }}
            </div>
        </div>

        <Transition>
            <div class="scrolldown" v-if="showScroll">
                <div></div>
            </div>
        </Transition>
    </div>
</template>

<script>
import PlayVideo from "../components/img/PlayVideo.vue";
import PauseVideo from "../components/img/PauseVideo.vue";
import Reload from "../components/img/Reload.vue";
import SoundOn from "../components/img/SoundOn.vue";
import SoundOff from "../components/img/SoundOff.vue";

export default {
    name: "VideoHome",
    data() {
        return {
            local: this.$i18n.locale,
            isMouseMove: false,
            timeoutMouseMove: false,
            isPlayingHome: false,
            scrollVal: 0,
            isMobile: false,
            soundMuted: true,
            srcVideoMp4: null,
            srcPoster: null,
            playPromise: false,
            timer: "",
            showScroll: false,
            endVideo: false,
        };
    },
    components: {
        PlayVideo,
        PauseVideo,
        SoundOn,
        SoundOff,
        Reload,
    },
    watch: {
        "$i18n.locale": function (locale) {
            this.local = locale;

            let windowWidth = window.innerWidth;
            if (windowWidth < 992) this.srcVideoMp4 = require(this.local == "fr" ? "@/assets/showreel_mobil.mp4" : "@/assets/showreel_mobil_en.mp4");
            else this.srcVideoMp4 = require(this.local == "fr" ? "@/assets/showreel.mp4" : "@/assets/showreel_en.mp4");
        },
        "$store.state.app.playVideoHome": {
            handler(isPlay) {
                let video = this.$refs["video_home"];
                if (video) {
                    if (isPlay) {
                        video.play();
                        this.isPlayingHome = true;
                    } else {
                        video.pause();
                        this.isPlayingHome = false;
                    }
                    this.isMouseMove = false;
                }
            },
        },
        "$store.state.app.resetHome": {
            handler(reset) {
                let video = this.$refs["video_home"];
                if (video && reset) {
                    this.isPlayingHome = false;
                    video.currentTime = 0;
                    this.$store.dispatch("app/setResetVideoHome", false);
                }
            },
        },
        "$store.state.app.loaderWebsite": {
            handler() {
                let video = this.$refs["video_home"];
                if (video) {
                    video.play();
                    this.isPlayingHome = true;
                }
            },
        },
    },
    mounted() {
        this.local = this.$i18n.locale;

        let _this = this;

        this.$store.dispatch("app/setPlayVideoHome", true);

        /**
         * Ajout class si version mobile
         */
        window.addEventListener("resize", function (e) {
            _this.isItMobile();
        });
        this.isItMobile();

        let video = this.$refs["video_home"];
        if (video) {
            video.addEventListener(
                "loadeddata",
                function () {
                    video.play();
                    _this.isPlayingHome = true;
                },
                false
            );

            video.addEventListener("timeupdate", function () {
                let videoDuration = video.duration;
                let remainingDuration = videoDuration - video.currentTime;
                //let hours = parseInt(remainingDuration / (60 * 60), 10);
                let minutes = parseInt(remainingDuration / 60, 10);
                let seconds = remainingDuration % 60;

                //hours = hours < 10 ? '0' + hours : hours;

                seconds = seconds.toFixed(0) < 10 ? "0" + seconds.toFixed(0) : seconds.toFixed(0);

                minutes = minutes < 10 ? "0" + minutes : minutes;
                _this.timer = minutes + ":" + seconds;
            });

            video.addEventListener("ended", function () {
                _this.showScroll = true;
                _this.endVideo = true;
                _this.$store.dispatch("app/setPlayVideoHome", false);
            });
        }
    },
    created() {
        this.srcVideoMp4 = window.innerWidth < 992 ? require(this.local == "fr" ? "@/assets/showreel_mobil.mp4" : "@/assets/showreel_mobil_en.mp4") : require(this.local == "fr" ? "@/assets/showreel.mp4" : "@/assets/showreel_en.mp4");
        this.srcPoster = window.innerWidth < 992 ? require("@/assets/img/home/poster_video_mobile.png") : require("@/assets/img/home/poster_video.png");

        window.addEventListener("scroll", this.handleScroll);
    },
    updated() {},
    unmounted() {
        this.$store.dispatch("app/setPlayVideoHome", false);
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll(e) {
            let video = this.$refs["video_home"];
            // PLAY / PAUSE
            if (video) {
                let videoHieght = video.clientHeight;
                if (!this.endVideo) {
                    if (videoHieght < window.scrollY) this.$store.dispatch("app/setPlayVideoHome", false);
                    else {
                        if (!this.$store.state.app.pauseVideoHomeByUser) this.$store.dispatch("app/setPlayVideoHome", true);
                    }
                }
            }
        },
        runMute(soundOn = false) {
            let video = this.$refs["video_home"];
            if (video) {
                video.muted = soundOn ? false : !video.muted;
                this.soundMuted = video.muted;
            }
        },
        playVideo() {
            this.$store.dispatch("app/setPlayVideoHome", !this.$store.state.app.playVideoHome);
            this.$store.dispatch("app/setPauseVideoHomeByUser", !this.$store.state.app.pauseVideoHomeByUser);
        },
        reloadVideo() {
            this.endVideo = false;
            this.showScroll = false;
            this.$store.dispatch("app/setResetVideoHome", false);
            this.$store.dispatch("app/setPlayVideoHome", true);
        },
        isItMobile() {
            let windowWidth = window.innerWidth;
            if (windowWidth < 992 && !this.isMobile) {
                this.isMobile = true;
                this.srcVideoMp4 = require(this.local == "fr" ? "@/assets/showreel_mobil.mp4" : "@/assets/showreel_mobil_en.mp4");
            } else if (windowWidth >= 992 && this.isMobile) {
                this.isMobile = false;
                this.srcVideoMp4 = require(this.local == "fr" ? "@/assets/showreel.mp4" : "@/assets/showreel_en.mp4");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#video-home {
    margin: auto;
    width: 100%;
    //max-width: 1350px;
    position: relative;

    video {
        width: 100%;
        //border-radius: 50px;
        overflow: hidden;
    }

    #timer-video {
        height: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        padding: 0 1rem;
        box-sizing: border-box;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;

        > div {
            position: sticky;
            top: calc(100vh - 35px - 1rem);
            z-index: 1;
            display: block;
            cursor: pointer;
            margin-bottom: 1rem;
            color: rgb(255, 255, 255, 0.5);
            height: 35px;
            display: flex;
            align-items: center;
            font-family: "Oswald", sans-serif;
            font-size: 1.2rem;
            font-weight: 600;
        }
    }

    #controls {
        height: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        padding: 0 1rem;
        box-sizing: border-box;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
    }

    .btn-reload,
    .btn-play {
        position: sticky;
        top: calc(100vh - 35px - 1rem);
        z-index: 1;
        display: block;
        cursor: pointer;
        margin-right: 0.5rem;
        margin-bottom: 1rem;

        svg {
            width: 35px;
        }
    }

    .btn-mute {
        position: sticky;
        top: calc(100vh - 35px - 1rem);
        z-index: 1;
        display: block;
        cursor: pointer;
        margin-bottom: 1rem;

        svg {
            width: 35px;
        }
    }
}

/* Scroll icon */
.scrolldown {
    position: absolute;
    top: 0;
    bottom: 2rem;
    height: calc(100% - 2rem);
    left: calc(50vw - 15px);
    display: flex;
    flex-flow: row nowrap;
    align-items: center;

    > div {
        position: absolute;
        width: 30px;
        height: 50px;
        border: 3px solid #ff0000;
        border-radius: 25px;
        position: sticky;
        top: calc(100vh - 50px - 2rem);
        transition: all 0.5s;

        &::before {
            content: "";
            position: absolute;
            bottom: 30px;
            left: 50%;
            transform: translateX(-50%);
            width: 6px;
            height: 6px;
            background-color: #ff0000;
            border-radius: 100%;
            box-shadow: 0px -5px 3px 1px rgba(255, 0, 0, 0.6);
            animation: scrolldown-anim 2s infinite;
        }

        &::after {
            content: "";
            position: absolute;
            bottom: -12px;
            left: 50%;
            transform: translateX(-50%) rotate(45deg);
            width: 7px;
            height: 7px;
            border: 2px solid #ff0000;
            border-top: none;
            border-left: none;
            animation: pulse 2s infinite;
        }
    }
}
@keyframes scrolldown-anim {
    0% {
        opacity: 0;
        height: 6px;
    }
    40% {
        opacity: 1;
        height: 10px;
    }
    80% {
        opacity: 0;
        transform: translate(-50%, 20px);
        height: 10px;
    }
    100% {
        opacity: 0;
        height: 3px;
    }
}

// Transition icone scroll
.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}

// HEIGHT
@media (max-height: 800px) {
}

@media (max-height: 650px) {
}

// WIDTH
@media (max-width: 1400px) {
}

@media (max-width: 1200px) {
}

@media (max-width: 992px) {
}

@media (max-width: 768px) {
}

@media (max-width: 576px) {
}
</style>
